@if (showSpinner) {
  <app-loader></app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="row main-heading-section">
      <!-- <div class="col-12 " [ngClass]="{ 'dark-text': selectedMode === 'dark' }"> -->
    <!-- </div> -->
    <div class="col-5 p-3" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
      <h3 class="font-weight-bold">
        <i class='fa fa-angle-left back-icon' (click)="navigateBack()" ></i>
        {{firstName}} {{lastName}} Annual Evaluation
      </h3>
    </div>
    <div class="add-new">
      @if (isavailablefeature('add') || isavailablefeature('update')) {
        <div class="btn btn-primary" (click)="addEvaluation(evaluations)">
          Add New Evaluation
        </div>
      }
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div style="height:180px">
        <canvas id="chLine"></canvas>
      </div>


    </div>


  </div>
  <div class="attendance-time-section mt-4 mb-3">
    <div class="row">
      <div class="col-sm-6 col-md-3 col-xl-3 timer">
        <div class="timer-inner my-2 d-flex  flex-row" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <img class="pr-2" src="../../../assets/images/excellent-tag.svg" alt="">
          <h1 class="pl-2">{{ getPointRemarks(showPoints) }}</h1>
        </div>
      </div>
      <div class="col-sm-6 col-md-3 col-xl-3 timer">
        <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <h1>THIS MONTH
          SATISFACTION</h1>
          <h1>{{monthlyAveragePoints}}%</h1>
        </div>
      </div>
      <div class="col-sm-6 col-md-3 col-xl-3 timer">
        <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <h1>12 MONTH
          SATISFACTION</h1>
          <h1>{{yearlyAveragePoints}}%</h1>
        </div>
      </div>
      <div class="col-sm-6 col-md-3 col-xl-3 timer">
        <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <h1>WARNING’S</h1>
          <h1> {{wariningPercentage}}%</h1>
        </div>
      </div>


    </div>
  </div>
  <!-- table -->
  <div class="attendance-report-table mt-4">
    <div class="attendance-report-table-header d-flex justify-content-around px-3">
      <div class="table-heading text-center">Date</div>
      <div class="table-heading text-center">TL Points</div>
      <div class="table-heading text-center">PM Points</div>
      <div class="table-heading text-center">Status</div>
      <div class="table-heading text-center">Publish</div>
      <div class="table-heading text-center ">View</div>
    </div>


    @for (evaluation of evaluations; track evaluation; let i = $index) {
      <div class="attendance-report-table-body d-flex justify-content-around px-3 my-4 my-md-0 py-4"
        style="background:{{
        getBackgroundPoint(evaluation.pm_points)
      }}; " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="table-cotent">
          <div class="table-content-heading">
            <h1>Date</h1>
          </div>
          <div class="table-content-value">
            <h1 class="text-md-center"> {{
              evaluation.year +
              "/" +
              evaluation.month +
              "/" +
              evaluation.date | date: "dd MMM yyyy"
            }}</h1>
          </div>
        </div>
        <div class="table-cotent">
          <div class="table-content-heading">
            <h1>Points</h1>
          </div>
          <div class="table-content-value text-md-center">
            <h1> {{ evaluation.points }}/10</h1>
          </div>
        </div>
        <div class="table-cotent">
          <div class="table-content-heading">
            <h1>PM_Points</h1>
          </div>
          <div class="table-content-value text-md-center">
            <h1> {{ evaluation.pm_points }}/10</h1>
          </div>
        </div>
        <div class="table-cotent py-2 py-md-0">
          <div class="table-content-heading">
            <h1>Status</h1>
          </div>
          <div class="table-content-value text-md-center">
            <h1 style="background-color: {{
            getColorPoint(evaluation.pm_points)
          }};border:1px solid {{
            getBorderPoint(evaluation.pm_points)
          }};color:{{
            getBorderPoint(evaluation.pm_points)
          }}">{{ getPointRemarks(evaluation.pm_points) }}</h1>
          </div>
        </div>
        <div class="table-cotent">
          <div class="table-content-heading">
            <h1>Publish</h1>
          </div>
          <div class="table-content-value text-md-center">
            <h1> {{ evaluation.is_evaluation == "1" ? 'Yes' : 'No' }}</h1>
          </div>
        </div>
        <!-- image eye -->
        <div class="table-cotent">
          <div class="table-content-heading">
            <h1>View</h1>
          </div>
          <div class="table-content-value text-md-center">
            <!-- <img (click)="showdata(evaluations[i])" class="pr-2" src="../../../assets/images/eye.png" alt="" style="cursor: pointer;"> -->
            <img (click)="getid(evaluation.id)" class="pr-2" src="../../../assets/images/eye.png" alt="" style="cursor: pointer;">
          </div>
        </div>
      </div>
    }


  </div>
</div>
<!-- <div class="mt-5" style="height: 404px"></div> -->
</main>
